import React, { useEffect, useRef, useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import CustomTable from '../../../shared/components/table/custom-table';
import { FloatingButtonContainer, InnerButton } from '../../../shared/components/buttons/floating-button-container';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import useNotification from '../../../shared/hooks/useNotification';
import { useApi } from '../../../shared/hooks/useApi';
import { LoaderComponent } from '../../../shared/components/loaders/page-loader';
import _ from 'lodash';
import { ETCAppConfig } from '../../../shared/app-configs/etc-app-configs';
import { payloadToJsonMap } from '../etc-models/IComponents-model';
import { Utills } from '../../../shared/app-configs/utilit';
import { StyledButton } from '../../../shared/components/buttons/custom-button';

const ComponentsDetails = () => {
  const { notify } = useNotification()
  const navigate = useNavigate();
  const { etcId, formtype } = useParams<string>()
  const [data, setData] = useState<any[]>([]);
  const { loading, executeGet } = useApi();
  // Refs for Form Steps
  const componentInfoRef = useRef<any>(null);
  const formRefs = [componentInfoRef];

  const fetchComponentDetails = async () => {
    try {
      const response: any = await executeGet(ETCAppConfig.GET_COMPONENTS_DETAILS, { etcId: etcId });
      Utills.cl("response ", response)
      const result = payloadToJsonMap(response.data);
      setData(result.data);
      Utills.cl("result", result)
    } catch (err) {
      console.error('Failed to fetch Components Details:', err);
    }
  }

  useEffect(() => {
      fetchComponentDetails()
  }, []);

  const columns: MRT_ColumnDef<any>[] = [
    { accessorKey: 'tcAssociatedProductNo', header: 'Associated Product No.', enableHiding: false, minSize: 60, maxSize: 150 },
    { accessorKey: 'tcProductComponentNo', header: 'eTC Product Component No.', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentDetail', header: 'eTC Component Detail', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentInfoTrimsExcluded', header: 'eTC Component Info Trims Excluded', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentInfoAssociatedTc', header: 'eTC Component Info Associated TC', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentInfoFiberLength', header: 'eTC Component Info Fiber Length', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentInfoYarnCount', header: 'eTC Product Component Info Yarn Count', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentInfoFabricWeightAndConstruct', header: 'eTC Component Info Fabric Weight And Construct', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentInfoFabricWeightOfFinishedProduct', header: 'eTC Component Info Fabric Weight of Finished Product', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentNetShippingWeight', header: 'eTC Component Net Shipping Weight', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentSupplementaryWeight', header: 'eTC Component Supplementary Weight', minSize: 60, maxSize: 150 },
    { accessorKey: 'tcComponentInfoAdditional', header: 'eTC Component Info Additional', minSize: 60, maxSize: 150 },
  ];
  const handleSave = async () => {
    navigate(`/etc/${formtype}/etc-product-details/${etcId}`)
  }
  const renderDetailPanel = ({ row }: { row: any }) => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 5,
          gap: 4,
          width: '50%',
        }}
      >
        {/* Product Component Standard Information */}
        <Box sx={{ width: '100%', textAlign: 'left', mb: 3 }} display="grid">
          <Typography variant="body2" fontWeight="400" sx={{ mb: 1 }}>
            eTC Components Details
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: 'tcComponentStandardLabelGrade',
                header: 'Standard Label Grade',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'tcComponentCertifiedWeight',
                header: 'Certified Weight',
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data= {data[0]["standard-info"]}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Raw Material Composition */}
        <Box sx={{ width: '100%', textAlign: 'left' }} display="grid">
          <Typography variant="body2" fontWeight="400" sx={{ mb: 1 }}>
            Raw Material Composition
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: 'tcComponentRawMaterialCode',
                header: 'Raw Material Code',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'tcComponentRawMaterialPercentage',
                header: 'Raw Material Percentage',
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={data[0]["raw-materials-info"]}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
      </Box>
    );
  };

  return (
    <>
      {loading ? <LoaderComponent /> : <>
        <Box display="grid">
          <CustomTable
            columns={columns}
            data={data}
            enableTopToolbar={false}
            enableBottomToolbar={true}
            renderDetailPanel={renderDetailPanel}
          />
        </Box>
        <Box sx={{
          display: "flex", justifyContent: "flex-end", mt: 2
        }}>
          <StyledButton variant="contained" onClick={handleSave}>
            Next
          </StyledButton>
          <NavLink to="/tc-dashboard">
            <StyledButton variant="contained">
              Cancel
            </StyledButton>
          </NavLink>
        </Box>
      </>}
    </>
  );
};

export default ComponentsDetails;
